"use client";

import { useEffect } from "react";
import { useCustomer } from "@/contexts/customer-context";
import { useNotificationsStore } from "../store/use-notifications-store";

export function useNotifications() {
  const { customer } = useCustomer();
  
  // Extraemos el estado y las acciones del store global (Zustand)
  const {
    notifications, 
    unreadCount, 
    hasMore,
    isLoadingMore,
    markAllAsRead, 
    markAsRead, 
    loadMore,
    initialize, 
    cleanup
  } = useNotificationsStore();

  // Efecto Maestro: Gestiona el ciclo de vida de la conexión global
  useEffect(() => {
    if (customer?.id) {
      // Inicia la conexión (Zustand ignora internamente si ya está conectado)
      initialize(customer.id);
    } else {
      // Si el usuario cierra sesión (customer es null/undefined), abortamos el túnel global
      cleanup();
    }
  }, [customer?.id, initialize, cleanup]);

  return { 
    notifications, 
    unreadCount, 
    hasMore,
    isLoadingMore,
    markAsRead, 
    markAllAsRead,
    loadMore
  };
}
